import React from 'react';
import { Link } from 'gatsby';
import { getGcUi } from '../../constants/spanish-gc';
import BookIconWhite from '../../images/svg-gcbooks/book-icon';
import './ChapterSummaryByline.scss';

const contentColumnWrap = (byline) => (
  <div className="wrapper wrapper-md gc-chapter-summary-byline-column gc-chapter-summary-byline-column--read">
    <div className="wrapper-sm gc-chapter-summary-byline-column__inner">
      <div className="r_s_c_inner">{byline}</div>
    </div>
  </div>
);

export default function ChapterSummaryByline({
  locale = 'en',
  beforeBody = false,
  contentLayout,
  readMoreHref,
}) {
  const ui = getGcUi(locale);

  const byline = (
    <div
      className={`gc-chapter-summary-byline${contentLayout ? ' gc-chapter-summary-byline--in-content' : ''}${
        beforeBody ? ' gc-chapter-summary-byline--before-body' : ''
      }${readMoreHref ? ' gc-chapter-summary-byline--with-cta' : ''}`}
      aria-labelledby="gc-chapter-summary-label"
    >
      <div className="gc-chapter-summary-byline__layout">
        <div className="gc-chapter-summary-byline__main">
          <div className="gc-chapter-summary-byline__row">
            <div className="gc-chapter-summary-byline__accent" aria-hidden="true" />
            <p className="gc-chapter-summary-byline__label" id="gc-chapter-summary-label">
              {ui.chapterSummaryLabel}
            </p>
          </div>
          <p className="gc-chapter-summary-byline__author">
            <span className="gc-chapter-summary-byline__by">{ui.chapterSummaryBy} </span>
            <span className="gc-chapter-summary-byline__author-name">{ui.chapterSummaryAuthor}</span>
          </p>
        </div>
        {readMoreHref ? (
          <div className="gc-chapter-summary-byline__actions">
            <p className="gc-chapter-summary-byline__read-more-lead">
              <span className="gc-chapter-summary-byline__read-more-label">{ui.readCompleteChapterLabel}</span>
              <span className="gc-chapter-summary-byline__read-more-arrow" aria-hidden="true">
                {' '}
                →
              </span>
            </p>
            <Link to={readMoreHref} className="btn btn-sm gcslogan gc-chapter-summary-byline__read-more-btn">
              <span className="gc-chapter-summary-byline__read-more-btn-icon" aria-hidden="true">
                <BookIconWhite color="#0a0a0a" viewBox="4 5 24 22" />
              </span>
              <span className="gc-chapter-summary-byline__read-more-btn-label">{ui.readMore}</span>
            </Link>
          </div>
        ) : null}
      </div>
    </div>
  );

  if (contentLayout === 'read') {
    return <div className="bg-light gc-chapter-summary-byline-section">{contentColumnWrap(byline)}</div>;
  }

  if (contentLayout === 'study') {
    return (
      <div className="gc-chapter-summary-byline-section bg-light">
        <div className="gc-text-section-padding gc-chapter-summary-byline-column gc-chapter-summary-byline-column--study">
          <div className="wrapper" style={{ display: 'flex', margin: 'auto' }}>
            <div className="r_s_inner">{byline}</div>
          </div>
        </div>
      </div>
    );
  }

  return byline;
}
